import React, { useState } from 'react';
import { Mail, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EmailVerificationBanner = ({ user }) => {
  const [sending, setSending] = useState(false);

  if (!user || user.email_verified !== false) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      await axios.post(`${API}/auth/resend-verification`, {}, { withCredentials: true });
      toast.success('Email de vérification envoyé ! Vérifiez votre boîte de réception.');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur lors de l\'envoi');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-amber-500/10 border border-amber-500/30 rounded-xl p-4 flex items-center justify-between gap-4 flex-wrap" data-testid="email-verification-banner">
      <div className="flex items-center gap-3">
        <Mail className="w-5 h-5 text-amber-400 shrink-0" />
        <p className="text-amber-200 text-sm">
          Votre adresse email n'est pas vérifiée. Vérifiez votre boîte de réception ou renvoyez le lien.
        </p>
      </div>
      <Button
        size="sm"
        onClick={handleResend}
        disabled={sending}
        className="bg-amber-500/20 hover:bg-amber-500/30 text-amber-300 border border-amber-500/30 shrink-0"
        data-testid="resend-verification-btn"
      >
        {sending ? <RefreshCw className="w-4 h-4 animate-spin mr-2" /> : <Mail className="w-4 h-4 mr-2" />}
        {sending ? 'Envoi...' : 'Renvoyer'}
      </Button>
    </div>
  );
};
